import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Typography,
  TextField,
  Grid,
  CircularProgress,
  Button,
  Paper,
  Tabs,
  Tab,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  Card,
  IconButton,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from "@mui/material";
import TabPanel from "../../component/TabPanel";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { parseISO } from "date-fns";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  deletePurchase,
  getPurchaseById,
  updatePurchase,
} from "../../api/purchase";
import { handleAxiosError } from "../../config/action-config";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridReact } from "ag-grid-react";
import {
  ticketViewersTable,
  ticketsAttachmentTable,
  ticketsAuditTable,
  ticketsUpdateTable,
} from "../../config/grid-columns-defs";
import { showAlert } from "../../actions/alert";
import {
  createAttachment,
  createNote,
  getAttachmentTicketTable,
  getAuditTicketTable,
  getPdfViewer,
  getTicketById,
  getUpdateTicketTable,
  updateAuditTicket,
} from "../../api/ticket";
import { CloudUpload, Delete } from "@mui/icons-material";
import { escalateTicket } from "../../api/escalate";
import ControlledTable from "../../component/ControlledTable";
import { getEmployeeList } from "../../api/employee";
import { DatePicker } from "@mui/x-date-pickers";
import {
  createTicketViewersById,
  deleteTicketViewersById,
  getTicketViewersById,
  getTicketViewersEmployees,
  getTicketViewersSubcustomers,
  getViewersById,
} from "../../api/viewers";
import DeleteAlertDialog from "../../component/DeleteAlertDialog";
import TicketViewersList from "../../component/customizedTicketViewersList";

const emptyTicketDetailData = {
  customer_id: "",
  severity: "",
  status: "",
  type: "",
  problem: "",
  downtime_from: "",
  downtime_to: "",
  due_date: "",
  problem_description: "",
  assigned: "",
  completed_ticket_date: "",
  created_by: "",
  created_date: "",
};

export default function ViewTickets() {
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isloading, setLoader] = useState(false);
  const [ticketDetailData, setTicketDetailData] = useState(
    emptyTicketDetailData
  );
  const [oldticketDetailData, setOldTicketDetailData] = useState({});
  const [tabIndex, setTabIndex] = useState(0);
  const [getUpdateTable, setUpdateTable] = useState([]);
  const [getAttachmentTable, setAttachmentTable] = useState([]);
  const [getAuditTable, setAuditTable] = useState([]);
  const [oldSeverity, setOldSeverity] = useState("");
  const [escalateStatus, setEscalateStatus] = useState(false);
  //UPDATE TAB
  const [totalCountUpdate, setTotalCountUpdate] = useState(0);
  const [rowsUpdate, setRowsUpdate] = useState([]);
  const [pageNumberUpdate, setPageNumberUpdate] = useState(0);
  //ATTACHMENTS TAB
  const [totalCountAttachments, setTotalCountAttachments] = useState(0);
  const [rowsAttachments, setRowsAttachments] = useState([]);
  const [pageNumberAttachments, setPageNumberAttachments] = useState(0);
  //AUDITTRAIL TAB
  const [totalCountAuditTrail, setTotalCountAuditTrail] = useState(0);
  const [rowsAuditTrail, setRowsAuditTrail] = useState([]);
  const [pageNumberAuditTrail, setPageNumberAuditTrail] = useState(0);
  const [employeesList, setEmployeesList] = useState([]);
  const [ticketViewersList, setTicketViewers] = useState([]);
  const [ticketViewersOptions, setTicketViewersOptions] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(-1);
  const [updateAccessStatus, setUpdateAccessStatus] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [customerId, setCustomerId] = useState("");
  useEffect(() => {
    employeeList();
  }, []);

  let objAction = ticketViewersTable.find((o) => o.headerName === "Action");
  if (objAction === undefined) {
    ticketViewersTable.unshift({
      headerName: "Action",
      field: "actions",
      resizable: true,
      wrapText: true,
      autoHeight: true,
      cellStyle: { fontSize: "11px" },
      minWidth: 65,
      maxWidth: 70,
      headerClass: "justify-center",
      cellClass: "justify-center",

      cellRendererFramework: (params) => (
        <IconButton
          color="info"
          onClick={() => {
            console.log("delete==", params.data);
            dispatch({ type: "DELETE", data: params.data });
          }}
        >
          <Delete fontSize="inherit" />
        </IconButton>
      ),
    });
  }
  let obj = ticketsAttachmentTable.find((o) => o.headerName === "Document");
  if (obj === undefined) {
    ticketsAttachmentTable.push({
      headerName: "Document",
      field: "file_name",
      resizable: true,
      minWidth: 180,

      cellRenderer: (params) => {
        const handleCellClick = async () => {
          setLoading(true); // Enable loading state before starting the action
          await getDocDownloadData(params.data.id);
        };

        return (
          <a href="#" onClick={handleCellClick}>
            {params.value}
          </a>
        );
      },
    });
  }

  const loadMasterData = () => {
    getTicketById(params.id, user.token)
      .then((res) => {
        setUpdateAccessStatus(res.data.updateAccess);
        setTicketDetailData(res.data.data);
        setOldTicketDetailData(res.data.data);
        setLoading(false);
        setEscalateStatus(res.data.data.escalate);
        setCustomerId(res.data.data.customer_id);
        if (/subcustomer|customer/i.test(user.role)) {
          if (res.data.data.customer_id) {
            getTicketViewersSubcustomersOptions(res.data.data.customer_id);
          }
        } else {
          getTicketViewersEmployeesOptions();
        }
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  const loadViewersById = () => {
    getTicketViewersById(params.id, user.token)
      .then((res) => {
        setTicketViewers(res.data.viewers);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  const convertToData = () => {
    let ticketViewers = {};
    if (/subcustomer|customer/i.test(user.role)) {
      ticketViewers = selectedUsers.map((id) => ({ subcustomer_id: id }));
    } else {
      ticketViewers = selectedUsers.map((id) => ({ employee_id: id }));
    }

    const data = { ticket_viewers: ticketViewers };
    return data;
  };
  const onTicketViewersAdd = async () => {
    setLoader(true);
    // const combinedData=
    try {
      const { data } = await createTicketViewersById(
        params.id,
        convertToData(),
        user.token
      );
      toggleDialogOpen("TICKET_VIEWERS");
      // dispatch(showAlert(data.message));
      loadViewersById();
      if (/subcustomer|customer/i.test(user.role)) {
        getTicketViewersSubcustomersOptions(ticketDetailData.customer_id);
      } else {
        getTicketViewersEmployeesOptions();
      }
      setSelectedValues([]);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      toggleDialogOpen("TICKET_VIEWERS");
      handleAxiosError(error, dispatch);
    }
  };
  //UPDATE TAB
  const getRowsUpdate = async (numRows, startRow) => {
    return getUpdateTicketTable(
      { ticketid: params.id, limit: numRows, offset: startRow },
      user.token
    )
      .then((res) => {
        setTotalCountUpdate(
          parseInt(res.data.data.total) === 0 ? -1 : res.data.data.total
        );
        console.log("datatta", res.data.data.ticketsAuditdata);
        return res.data.data.ticketsAuditdata;
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        return [];
      });
  };
  const refreshTableUpdate = async () => {
    try {
      const { data } = await getUpdateTicketTable(
        { ticketid: params.id, limit: 10, offset: 0 },
        user.token
      );

      setTotalCountUpdate(
        parseInt(data.data.total) === 0 ? -1 : parseInt(data.data.total)
      );
      setRowsUpdate(data.data.ticketsAuditdata);
    } catch (err) {
      handleAxiosError(err, dispatch);
    }
  };
  //ATTACHMENTS TAB
  const getRowsAttachmnets = async (numRows, startRow) => {
    return getAttachmentTicketTable(
      { ticketid: params.id, limit: numRows, offset: startRow },
      user.token
    )
      .then((res) => {
        setTotalCountAttachments(
          parseInt(res.data.data.total) === 0 ? -1 : res.data.data.total
        );
        return res.data.data.ticketsAttachement;
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        return [];
      });
  };
  const refreshTableAttachmnets = async () => {
    try {
      const { data } = await getAttachmentTicketTable(
        { ticketid: params.id, limit: 10, offset: 0 },
        user.token
      );

      setTotalCountAttachments(
        parseInt(data.data.total) === 0 ? -1 : parseInt(data.data.total)
      );
      setRowsAttachments(data.data.ticketsAttachement);
    } catch (err) {
      handleAxiosError(err, dispatch);
    }
  };
  //AUDITTRAIL TAB
  const getRowsAuditTrail = async (numRows, startRow) => {
    return getAuditTicketTable(
      { ticketid: params.id, limit: numRows, offset: startRow },
      user.token
    )
      .then((res) => {
        setTotalCountAuditTrail(
          parseInt(res.data.data.total) === 0 ? -1 : res.data.data.total
        );
        return res.data.data.ticketsAuditdata;
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        return [];
      });
  };
  const refreshTableAuditTrail = async () => {
    try {
      const { data } = await getAuditTicketTable(
        { ticketid: params.id, limit: 10, offset: 0 },
        user.token
      );

      setTotalCountAuditTrail(
        parseInt(data.data.total) === 0 ? -1 : parseInt(data.data.total)
      );
      setRowsAuditTrail(data.data.ticketsAuditdata);
    } catch (err) {
      handleAxiosError(err, dispatch);
    }
  };
  // const getTicketUpdateTableData = async () => {
  //   await getUpdateTicketTable(params.id, user.token)
  //     .then((res) => {
  //       setUpdateTable(res.data.data.ticketsAuditdata);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       handleAxiosError(err, dispatch);
  //     });
  // };
  // const getTicketAttachmentTableData = async () => {
  //   await getAttachmentTicketTable(params.id, user.token)
  //     .then((res) => {
  //       setAttachmentTable(res.data.data.ticketsAttachement);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       handleAxiosError(err, dispatch);
  //     });
  // };
  // const getTicketAuditTableData = async () => {
  //   await getAuditTicketTable(params.id, user.token)
  //     .then((res) => {
  //       setAuditTable(res.data.data.ticketsAuditdata);
  //       console.log("auditdata===", res.data.data.ticketsAuditdata);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       handleAxiosError(err, dispatch);
  //     });
  // };

  useEffect(() => {
    if (!params.id) {
    } else {
      fetchApis();
    }
  }, [params.id]);

  const fetchApis = async () => {
    try {
      await Promise.all([
        loadMasterData(),
        loadViewersById(),
        // getTicketUpdateTableData(),
        // getTicketAttachmentTableData(),
        // getTicketAuditTableData(),
      ]);
    } catch {
      throw Error("Promise failed");
    }
  };

  const onInputChange = (e) => {
    setTicketDetailData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const [itemDialog, setItemDialog] = useState({
    UPDATE_TAB: false,
    ATTACHMENTS_TAB: false,
    TICKET_VIEWERS: false,
  });
  function toggleDialogOpen(dialog) {
    setItemDialog((prev) => ({ ...prev, [dialog]: !itemDialog[dialog] }));
  }
  const [selectedItemRow, setSelectedItemRow] = useState(0);
  const onItemDialogSubmit = async (postData) => {
    try {
      const { data } = await createNote(
        { ...postData, ticket_id: params.id },
        user.token
      );
      refreshTableUpdate();
      // getTicketUpdateTableData();
      dispatch(showAlert(data.msg));
      toggleDialogOpen("UPDATE_TAB");
    } catch (error) {
      toggleDialogOpen("UPDATE_TAB");
      handleAxiosError(error, dispatch);
    }
  };

  const onItemDialogAttachmentSubmit = async (formData) => {
    try {
      const { data } = await createAttachment(formData, params.id, user.token);
      refreshTableAttachmnets();
      // getTicketAttachmentTableData();
      dispatch(showAlert(data.msg));
      toggleDialogOpen("ATTACHMENTS_TAB");
    } catch (error) {
      toggleDialogOpen("ATTACHMENTS_TAB");
      handleAxiosError(error, dispatch);
    }
  };
  const onAuditTicketSubmit = async () => {
    const newSeverity = ticketDetailData.severity;
    const newStatus = ticketDetailData.status;
    const newFlag = ticketDetailData.flag;
    const newAssigned = ticketDetailData.assigned;
    if (
      newSeverity === oldticketDetailData.severity &&
      newStatus === oldticketDetailData.status &&
      newFlag === oldticketDetailData.flag &&
      newAssigned === oldticketDetailData.assigned
    ) {
      if (user.role === "Customer" || user.role === "Subcustomer") {
        return dispatch(showAlert("Please update the Severity/Status"));
      }
      return dispatch(
        showAlert("Please update the Severity/Status/Assigned To")
      );
    }
    const combineData = {
      status: ticketDetailData.status,
      severity: ticketDetailData.severity,
      flag: ticketDetailData.flag,
      assigned: ticketDetailData.assigned,
    };
    // const combineData = {
    //   severity_column: "severity",
    //   severity_oldvalue: oldticketDetailData.severity,
    //   severity_newvalue: newSeverity,
    //   status_column: "status",
    //   status_oldvalue: oldticketDetailData.status,
    //   status_newvalue: newStatus,
    //   customer_id: oldticketDetailData.customer_id,
    //   ticket_id: params.id,
    //   flag: ticketDetailData.flag,
    // };

    try {
      const { data } = await updateAuditTicket(
        combineData,
        user.token,
        params.id
      );

      // getTicketAuditTableData();
      // loadMasterData();
      dispatch(showAlert(data.msg));
      navigate(-2);

      // refreshTableAuditTrail();
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };
  const getDocDownloadData = async (id) => {
    if (loading) {
      return;
    }

    setLoading(true);

    try {
      const token = user.token;
      const blob = await getPdfViewer(id, token);
      const file = window.URL.createObjectURL(blob.data);
      setLoading(false);
      window.open(file, "_blank");
    } catch (err) {
      setLoading(false);
      handleAxiosError(err, dispatch);
    }
  };
  const getescalateTicket = async (id) => {
    await escalateTicket({ ticketid: id }, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.success));
        setEscalateStatus(true);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  const employeeList = async () => {
    const token = user.token;
    return await getEmployeeList(token)
      .then((res) => {
        setEmployeesList(res.data.EmployeeList);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  const getTicketViewersEmployeesOptions = async () => {
    const token = user.token;
    return await getTicketViewersEmployees(params.id, token)
      .then((res) => {
        setTicketViewersOptions(res.data.employees);
      })
      .catch((err) => {
        console.log(err);
        handleAxiosError(err, dispatch);
      });
  };
  const getTicketViewersSubcustomersOptions = async (id) => {
    const token = user.token;
    return await getTicketViewersSubcustomers(
      { customer_id: id || customerId },
      params.id,
      token
    )
      .then((res) => {
        setTicketViewersOptions(res.data.subcustomers);
      })
      .catch((err) => {
        console.log(err);
        handleAxiosError(err, dispatch);
      });
  };

  // useEffect(() => {
  //   if (/subcustomer|customer/i.test(user.role)) {
  //     if (ticketDetailData.customer_id) {
  //       getTicketViewersSubcustomersOptions();
  //     }
  //   } else {
  //     getTicketViewersEmployeesOptions();
  //   }
  // }, []);
  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "DELETE":
        setDeleteDialogOpen(true);
        break;

      default:
        break;
    }
  }, [dialogAction]);
  useEffect(() => {
    if (deleteId === -1) return;
    setLoader(true);
    deleteTicketViewersById(params.id, deleteId, user.token)
      .then((res) => {
        // dispatch(showAlert(res.data.message));
        setDeleteId(-1);
        loadViewersById();
        if (/subcustomer|customer/i.test(user.role)) {
          getTicketViewersSubcustomersOptions(ticketDetailData.customer_id);
        } else {
          getTicketViewersEmployeesOptions();
        }
        // refreshTable();
        setLoader(false);
        setDeleteDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setDeleteId(-1);
        setDeleteDialogOpen(false);
      });
  }, [deleteId]);
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ p: "1rem" }}>
        <Typography variant="h6">{oldticketDetailData.ticketid}</Typography>
        <Box
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            borderBottom: 1,
            justifyContent: "flex-end",
          }}
        >
          {user.role === "Customer" || user.role === "Subcustomer" ? (
            escalateStatus === true ? (
              <Button
                variant="contained"
                style={{ padding: "5px 7px" }}
                className="blue-button"
              >
                Escalated
              </Button>
            ) : (
              <Button
                variant="contained"
                style={{ padding: "5px 7px" }}
                onClick={() => {
                  getescalateTicket(params.id);
                }}
                className="blue-button"
              >
                Escalate
              </Button>
            )
          ) : (
            <div></div>
          )}
          <TicketViewersList
            isloading={isloading}
            isListOpen={itemDialog.TICKET_VIEWERS}
            setIsListOpen={toggleDialogOpen}
            ticketViewersList={ticketViewersList}
            employeesList={ticketViewersOptions}
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            onSubmit={onTicketViewersAdd}
            deleteId={deleteId}
            setDeleteId={setDeleteId}
          ></TicketViewersList>
        </Box>
        <Grid container spacing={2} sx={{ pt: "1rem" }}>
          <Grid item xs={12} md={6} sm={6} lg={4}>
            <TextField
              value={ticketDetailData.company_name || ""}
              label="Customer Name"
              name="company_name"
              // onChange={onInputChange}
              // required
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} md={6} sm={6} lg={4}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Severity</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={ticketDetailData.severity.toUpperCase()}
                label="Severity"
                name="severity"
                onChange={onInputChange}
                disabled={
                  oldticketDetailData.status === "CLOSED" ? true : false
                }
              >
                <MenuItem value="HIGH">HIGH</MenuItem>
                <MenuItem value="LOW">LOW</MenuItem>
                <MenuItem value="MEDIUM">MEDIUM</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} sm={6} lg={4}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <Select
                // labelId="demo-simple-select-label"
                // id="demo-simple-select"
                value={ticketDetailData.status.toUpperCase()}
                label="Status"
                name="status"
                onChange={onInputChange}
                disabled={
                  oldticketDetailData.status === "CLOSED" ? true : false
                }
              >
                <MenuItem value="CLOSED">CLOSED</MenuItem>
                <MenuItem value="OPEN">OPEN</MenuItem>
                <MenuItem value="WORK IN PROGRESS">WORK IN PROGRESS</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {user.role === "Customer" || user.role === "Subcustomer" ? (
            <></>
          ) : (
            <Grid item xs={12} md={6} sm={6} lg={4}>
              <FormControl required fullWidth>
                <InputLabel id="demo-simple-select-label">Ticket</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={ticketDetailData.flag || ""}
                  label="Ticket"
                  name="flag"
                  disabled={
                    user.role === "Customer" ||
                    user.role === "Subcustomer" ||
                    oldticketDetailData.status === "CLOSED"
                      ? true
                      : false
                  }
                  onChange={onInputChange}
                >
                  <MenuItem value={"E"}>External</MenuItem>
                  <MenuItem value={"I"}>Internal</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12} md={6} sm={6} lg={4}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={ticketDetailData.type}
                label="Type"
                name="type"
                disabled
                //   onChange={onInputChange}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="ACCOUNT ISSUE">Account Issue</MenuItem>
                <MenuItem value="INCIDENT">Incident</MenuItem>
                <MenuItem value="OTHER">Other</MenuItem>
                <MenuItem value="PROBLEM">Problem</MenuItem>
                <MenuItem value="QUESTION">Question</MenuItem>
                <MenuItem value="TASK">Task</MenuItem>
                <MenuItem value="USAGE PROBLEM">Usage Problem</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} sm={6} lg={4}>
            <TextField
              // margin="dense"
              name="subject"
              fullWidth
              disabled
              value={ticketDetailData.problem || ""}
              //   onChange={changeUpdateData}
              label="Subject"
              type="text"
              variant="outlined"
              //   disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6} lg={4}>
            <FormControl size="small" fullWidth>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  disabled
                  label="Downtime From"
                  value={ticketDetailData.downtime_from || ""}
                  // onChange={(nv) => {
                  //   onInputChange({
                  //     target: {
                  //       name: "downtime_from",
                  //       value: new Date(nv).toISOString(),
                  //     },
                  //   });
                  // }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} sm={6} lg={4}>
            <FormControl size="small" fullWidth>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  disabled
                  label="Downtime To"
                  value={ticketDetailData.downtime_to || ""}
                  // onChange={(nv) => {
                  //   onInputChange({
                  //     target: {
                  //       name: "downtime_to",
                  //       value: new Date(nv).toISOString(),
                  //     },
                  //   });
                  // }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} sm={6} lg={4}>
            <FormControl size="small" fullWidth>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  disabled
                  label="Due Date"
                  value={ticketDetailData.due_date || ""}
                  // onChange={(nv) => {
                  //   onInputChange({
                  //     target: {
                  //       name: "due_date",
                  //       value: new Date(nv).toISOString(),
                  //     },
                  //   });
                  // }}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} sm={6} lg={4}>
            <TextField
              name="description"
              fullWidth
              value={ticketDetailData.problem_description || ""}
              disabled
              multiline
              rows={4} // adjust this value to increase or decrease the number of rows
              rowsMax={10}
              //   onChange={changeUpdateData}
              label="Description"
              type="text"
              variant="outlined"
              //   disabled={editDisabled}
            />
          </Grid>

          {user.role === "Customer" || user.role === "Subcustomer" ? (
            <Grid item xs={12} md={6} sm={6} lg={4}>
              <TextField
                value={ticketDetailData.assigned || ""}
                label="Assigned To"
                name="assigned"
                onChange={onInputChange}
                // required
                fullWidth
                disabled
              />
            </Grid>
          ) : (
            <Grid item xs={12} md={6} sm={6} lg={4}>
              <FormControl required fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Assigned To
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={ticketDetailData.assigned || ""}
                  label="Assigned To"
                  name="assigned"
                  // disabled={user.role === "Support" ? false : true}
                  onChange={(event) => {
                    let selectedCustomer = employeesList.find((s) => {
                      return s.email === event.target.value;
                    });

                    onInputChange({
                      target: {
                        name: "assigned",
                        value: selectedCustomer.email.toString(),
                      },
                    });
                  }}
                >
                  {employeesList.map((c, i) => (
                    <MenuItem key={i} value={c.email}>
                      {c.email}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}

          {oldticketDetailData.status === "OPEN" ||
          oldticketDetailData.status === "WORK IN PROGRESS" ? (
            <></>
          ) : (
            <Grid item xs={12} md={6} sm={6} lg={4}>
              <FormControl size="small" fullWidth>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    disabled
                    label="Resolved Date"
                    value={ticketDetailData.completed_ticket_date || ""}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
          )}

          <Grid item xs={12} md={6} sm={6} lg={4}>
            <FormControl size="small" fullWidth>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  disabled
                  label="Created Date"
                  value={ticketDetailData.created_date || ""}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            {updateAccessStatus === true ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  columnGap: 1,
                  ml: "auto",
                }}
              >
                <Button
                  disabled={/^Trial_User$/i.test(user.role) ? true : false}
                  variant="contained"
                  onClick={onAuditTicketSubmit}
                  style={{ padding: "5px 7px" }}
                  className="blue-button"
                >
                  Update
                </Button>
              </Box>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </Paper>
      <br />

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Notes"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="Attachments"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="Audit Trail"
            id="simple-tab-2"
            aria-controls="simple-tabpanel-2"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          {/* <Tab
            label="Ticket Viewers"
            id="simple-tab-3"
            aria-controls="simple-tabpanel-3"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          /> */}
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <Paper>
          <Box sx={{ display: "flex", columnGap: 1, p: 2, borderBottom: 1 }}>
            <Button
              variant="contained"
              style={{ padding: "5px 7px" }}
              onClick={() => {
                toggleDialogOpen("UPDATE_TAB");
              }}
              className="blue-button"
            >
              Add
            </Button>
          </Box>
          <div
            className="ag-theme-material pmt-controll-table"
            // style={{ height: "300px" }}
          >
            {/* {"No Updates"} */}
            {/* <AgGridReact
              columnDefs={ticketsUpdateTable}
              rowData={getUpdateTable}
              rowSelection="single"
              onRowClicked={(params) => {
                setSelectedItemRow(params.data.id);
              }}
            /> */}

            <ControlledTable
              rows={rowsUpdate}
              columnDefs={ticketsUpdateTable}
              getRows={getRowsUpdate}
              totalCount={totalCountUpdate}
              onChange={setRowsUpdate}
              onPageNumberChange={setPageNumberUpdate}
              pageSize={10}
              pageNumber={pageNumberUpdate}
              pagination={true}
              // getRowNodeId={(data) => data?.name || data?.index}
              hasActionButtons={false}
            />
          </div>
        </Paper>
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <Paper>
          <Box
            sx={{
              display: "flex",
              columnGap: 1,
              p: 2,
              borderBottom: 1,
              justifyContent: "space-between",
            }}
          >
            <Button
              variant="contained"
              style={{ padding: "5px 7px" }}
              onClick={() => {
                toggleDialogOpen("ATTACHMENTS_TAB");
              }}
              className="blue-button"
            >
              Add
            </Button>
            {isloading === false ? (
              <div></div>
            ) : (
              <div>Fetching Document...</div>
            )}
          </Box>
          <div
            className="ag-theme-material pmt-controll-table"
            //style={{ height: "300px" }}
          >
            {/* {"No Attachments"} */}
            {/* <AgGridReact
              columnDefs={ticketsAttachmentTable}
              rowData={getAttachmentTable}
              rowSelection="single"
              onRowClicked={(params) => {
                setSelectedItemRow(params.data.id);
              }}
              defaultColDef={{
                flex: 1,
                minWidth: 100,
              }}
            /> */}
            <ControlledTable
              rows={rowsAttachments}
              columnDefs={ticketsAttachmentTable}
              getRows={getRowsAttachmnets}
              totalCount={totalCountAttachments}
              onChange={setRowsAttachments}
              onPageNumberChange={setPageNumberAttachments}
              pageSize={10}
              pageNumber={pageNumberAttachments}
              pagination={true}
              // getRowNodeId={(data) => data?.name || data?.index}
              hasActionButtons={false}
            />
          </div>
          {loading && (
            <div className="overlay">
              <Loading></Loading>
            </div>
          )}
        </Paper>
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <Paper>
          <Box sx={{ display: "flex", columnGap: 1, p: 2 }}></Box>
          <div
            className="ag-theme-materialpmt-controll-table"
            //style={{ height: "300px" }}
          >
            {/* {"No Audit Trial"} */}
            {/* <AgGridReact
              columnDefs={ticketsAuditTable}
              rowData={getAuditTable}
              rowSelection="single"
              onRowClicked={(params) => {
                setSelectedItemRow(params.data.id);
              }}
              defaultColDef={{
                flex: 1,
                minWidth: 100,
              }}
            /> */}

            <ControlledTable
              rows={rowsAuditTrail}
              columnDefs={ticketsAuditTable}
              getRows={getRowsAuditTrail}
              totalCount={totalCountAuditTrail}
              onChange={setRowsAuditTrail}
              onPageNumberChange={setPageNumberAuditTrail}
              pageSize={10}
              pageNumber={pageNumberAuditTrail}
              pagination={true}
              // getRowNodeId={(data) => data?.name || data?.index}
              hasActionButtons={false}
            />
          </div>
        </Paper>
      </TabPanel>
      {/* <TabPanel value={tabIndex} index={3}>
        <Paper sx={{ p: 2 }}>
          <Box
            sx={{
              display: "flex",
              columnGap: 1,
              pb: 2,
              borderBottom: 1,
              justifyContent: "space-between",
            }}
          >
            <Button
              variant="contained"
              style={{ padding: "5px 7px" }}
              onClick={() => {
                toggleDialogOpen("TICKET_VIEWERS");
              }}
              className="blue-button"
            >
              Add Viewers
            </Button>
          </Box>

          <div className="ag-theme-material pmt-controll-table">
            <AgGridReact
              columnDefs={ticketViewersTable}
              domLayout="autoHeight"
              rowData={ticketViewersList}
              defaultColDef={{
                resizable: true,
                flex: 1,
              }}
              // rowSelection="single"
              // onRowClicked={(params) => { setSelectedProjectRow(params.data.ep_id) }}
            />
          </div>
        </Paper>
      </TabPanel> */}
      <DeleteAlertDialog
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        setDeleteId={setDeleteId}
        rowId={dialogAction.data?.id}
      />
      <ItemDialogTicketViewers
        open={itemDialog.TICKET_VIEWERS}
        setOpen={toggleDialogOpen}
        employeesList={ticketViewersOptions}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        setSelectedUsers={setSelectedUsers}
        onSubmit={onTicketViewersAdd}
        isloading={isloading}
      />

      <ItemDialogUpdateTab
        open={itemDialog.UPDATE_TAB}
        setOpen={toggleDialogOpen}
        onSubmit={onItemDialogSubmit}
      />

      <ItemDialogAttachmentsTab
        open={itemDialog.ATTACHMENTS_TAB}
        setOpen={toggleDialogOpen}
        onSubmit={onItemDialogAttachmentSubmit}
      />
    </Box>
  );
}
// function dateFormatted(created_date) {
//   const createdDate = new Date(created_date);
//   const month = createdDate.getMonth() + 1; // getMonth() returns 0-based index
//   const day = createdDate.getDate();
//   const year = createdDate.getFullYear();

//   const formattedDate = `${month}/${day}/${year}`;
//   return formattedDate;
// }

function ItemDialogTicketViewers({
  open,
  setOpen,
  employeesList,
  setSelectedValues,
  selectedValues,
  setSelectedUsers,
  onSubmit,
  isloading,
}) {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [data, setData] = useState(emptyItemData);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const handleSelectionChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedValues(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  useEffect(() => {
    collectData(selectedValues.map((i) => employeesList[i]));
    // console.log(ids)
  }, [selectedValues]);
  function collectData(list) {
    setSelectedUsers(list.map((a) => a.id));
  }
  return (
    <Dialog
      open={open}
      onClose={() => {
        //setOpen("UPDATE_TAB");
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
        ADD TICKET VIEWERS
      </DialogTitle>
      <DialogContent>
        <Grid container width={500} spacing={1} py={1}>
          <Grid item xs={12} md={12}>
            {/* <FormControl fullWidth>
              <InputLabel>Select Options</InputLabel>
              <Select
                multiple
                value={selectedValues}
                onChange={handleSelectionChange}
                inputProps={{
                  name: "options",
                  id: "options-select",
                }}
              >
                {employeesList.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.email}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
            <FormControl size="small" fullWidth>
              <InputLabel id="demo-multiple-checkbox-label">
                {"Ticket Viewers"}
              </InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                fullWidth
                value={selectedValues}
                onChange={handleSelectionChange}
                input={<OutlinedInput label={"Users"} fullWidth />}
                renderValue={(selected) =>
                  selected.map((s) => employeesList[s].firstname).join(", ")
                }
                MenuProps={MenuProps}
              >
                {employeesList.map((u, idx) => (
                  <MenuItem key={idx} value={idx}>
                    <Checkbox checked={selectedValues.indexOf(idx) > -1} />
                    <ListItemText primary={u.firstname} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          className="cancel-button"
          onClick={() => {
            setOpen("TICKET_VIEWERS");
            setSelectedValues([]);
          }}
        >
          Cancel
        </Button>

        {selectedValues.length ? (
          <Box sx={{ ml: 1 }}>
            {!isloading ? (
              <Button
                disabled={/^Trial_User$/i.test(user.role) ? true : false}
                variant="contained"
                onClick={onSubmit}
                style={{ padding: "5px 7px" }}
                className="blue-button"
              >
                Submit
              </Button>
            ) : (
              <Box sx={{ ml: 1 }}>
                <CircularProgress />
              </Box>
            )}
          </Box>
        ) : (
          <></>
        )}
      </DialogActions>
    </Dialog>
  );
}
const emptyItemData = {
  note: "",
};
function ItemDialogUpdateTab({ open, setOpen, onSubmit }) {
  const [data, setData] = useState(emptyItemData);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const submit = () => {
    if (!data.note) {
      setOpen("UPDATE_TAB");
      return dispatch(showAlert("Note can't be empty"));
    } else {
      onSubmit(data);
      setData(emptyItemData);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        //setOpen("UPDATE_TAB");
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "500px", // Set your width here
          },
        },
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
        ADD/ Update Note
      </DialogTitle>
      <DialogContent>
        <Grid container width={500} spacing={1} py={1}>
          <Grid item xs={12} md={12}>
            <TextField
              type="text"
              onChange={handleChange}
              value={data.note}
              multiline
              rows={4} // adjust this value to increase or decrease the number of rows
              rowsMax={10}
              label="Note"
              name="note"
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          className="cancel-button"
          onClick={() => {
            setOpen("UPDATE_TAB");
            setData(emptyItemData);
          }}
        >
          Cancel
        </Button>
        <Button
          disabled={/^Trial_User$/i.test(user.role) ? true : false}
          className="blue-button"
          onClick={submit}
        >
          {"Add Note"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
function ItemDialogAttachmentsTab({ open, setOpen, onSubmit }) {
  const [data, setData] = useState(emptyItemData);
  const [loader, setLoader] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [isSelected, setIsSelected] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const submit = () => {
    const formData = new FormData();
    if (selectedFile == "") {
      setOpen("ATTACHMENTS_TAB");
      return dispatch(showAlert("Attachment can't be empty"));
    }
    const appenddata = formData.append("myFile", selectedFile);

    setLoader(true);
    onSubmit(formData).then(() => {
      setLoader(false);
      setIsSelected(false);
      setSelectedFile("");
    });
  };

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  const formatLastModifiedDate = (file) => {
    if (file && file.lastModified) {
      const lastModifiedTimestamp = file.lastModified;
      const lastModifiedDate = new Date(lastModifiedTimestamp);
      return lastModifiedDate.toLocaleDateString();
    }
    return "";
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        //  setOpen("ATTACHMENTS_TAB");
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
        Attachments
      </DialogTitle>
      <DialogContent>
        <Grid container width={500} spacing={1} py={1}>
          <Grid item xs={12} md={12}>
            <Card sx={{ boxShadow: "none !important" }}>
              <div class="upload-files-container">
                <div class="drag-file-area">
                  <div class="upload-icon">
                    <CloudUpload sx={{ fontSize: 40, color: "#08459c" }} />
                  </div>
                  <h6 class="dynamic-message"> Drag & drop any file here </h6>
                  <div class="browse-files">
                    <input
                      className="file-upload"
                      type="file"
                      name="file"
                      onChange={changeHandler}
                    />
                    {isSelected ? (
                      <Box>
                        <Typography>Filename: {selectedFile.name}</Typography>
                        <Typography>Filetype: {selectedFile.type}</Typography>
                        <Typography>
                          Size in bytes: {selectedFile.size}
                        </Typography>
                        <Typography>
                          lastModifiedDate:{" "}
                          {formatLastModifiedDate(selectedFile)}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography>Select a file to show details</Typography>
                    )}
                  </div>
                </div>
              </div>
            </Card>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          className="cancel-button"
          onClick={() => {
            setOpen("ATTACHMENTS_TAB");
            setIsSelected(false);
            setSelectedFile("");
          }}
        >
          Cancel
        </Button>
        {loader === false ? (
          <Button
            disabled={/^Trial_User$/i.test(user.role) ? true : false}
            className="blue-button"
            onClick={submit}
          >
            {"Add Attachments"}
          </Button>
        ) : (
          <Box sx={{ display: "flex" }}>
            <CircularProgress />
          </Box>
        )}
      </DialogActions>
    </Dialog>
  );
}

function Loading() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <CircularProgress />
      </div>
    </div>
  );
}
